module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng1.22152a90.png";